export default  {
    bindings: {
        discount: '<',
        formTab: '='
    },
    controller: 'discountPeriodFormController',
    template: require('../views/discount.period.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/components/discount.period.form.component.js